export default __webpack_public_path__ + "static/media/404.04860735.svg";